const SITE_URL = 'https://mobidicsaju.com';
const SITE_NAME = '사주팔자AI';
const SITE_NAMES = {
  ko: '사주팔자AI',
  en: 'SajuPaljaAI',
  ja: '四柱八字AI',
  ru: 'Саджу AI',
  de: 'SajuPaljaAI',
};
const DEFAULT_LOCALE = 'ko';
const LOCALES = ['ko', 'en', 'ja', 'ru', 'de'];
const PREFIXED_LOCALES = LOCALES.filter(locale => locale !== DEFAULT_LOCALE);
const OG_LOCALES = {
  ko: 'ko_KR',
  en: 'en_US',
  ja: 'ja_JP',
  ru: 'ru_RU',
  de: 'de_DE',
};

const descriptions = {
  home: {
    ko: '전통 사주와 햄묘·커냥·산할아버지·삼신할머니의 AI 채팅 상담. 같은 정통 만세력을 바탕으로 따뜻한 위로, 현실적인 해결, 삶의 지혜, 인연의 돌봄을 만나보세요.',
    en: 'Traditional Saju readings and AI chats with Hammyo, Keonyang, the Mountain Elder and Granny Samshin. One birth-chart engine, four approaches to comfort, clarity, wisdom and care.',
    ja: '伝統四柱推命と、ハムミョ・コニャン・山のおじいさん・サムシンおばあさんのAIチャット相談。同じ命式をもとに、慰め・解決・人生の知恵・縁のいたわりを届けます。',
    ru: 'Традиционный Саджу и ИИ-беседы с Хаммё, Конян, горным дедушкой и бабушкой Самсин. Единый расчёт карты рождения, четыре подхода: поддержка, ясность, мудрость и забота.',
    de: 'Traditionelles Saju und KI-Chats mit Hammyo, Keonyang, Bergopa und Oma Samshin. Eine gemeinsame Geburtsberechnung für Trost, klare Lösungen, Lebensweisheit und Fürsorge.',
  },
  service: {
    ko: '사주팔자AI의 전문 분석 도구로 나의 운세와 삶의 흐름을 깊이 있게 살펴보세요.',
    en: 'Use SajuPaljaAI analysis tools to explore your fortune, character, and the patterns shaping your life.',
    ja: '四柱八字AIの専門分析ツールで、運勢や性格、人生の流れを詳しく読み解きます。',
    ru: 'Исследуйте судьбу, характер и жизненные циклы с помощью аналитических инструментов Саджу ИИ.',
    de: 'Erkunden Sie Schicksal, Charakter und Lebensphasen mit den Analysewerkzeugen von SajuPaljaAI.',
  },
  community: {
    ko: '사주팔자AI 이용자와 콘텐츠를 나누고 다양한 운세 이야기를 만나보세요.',
    en: 'Discover shared readings, stories, and conversations from the SajuPaljaAI community.',
    ja: '四柱八字AIコミュニティの鑑定、物語、さまざまな運勢の話題を楽しめます。',
    ru: 'Читайте материалы, истории и обсуждения сообщества Саджу ИИ.',
    de: 'Entdecken Sie Deutungen, Geschichten und Gespräche aus der SajuPaljaAI-Community.',
  },
  company: {
    ko: '사주팔자AI 서비스와 비즈니스, 개발자 연동 정보를 확인하세요.',
    en: 'Find service, business, and developer integration information for SajuPaljaAI.',
    ja: '四柱八字AIのサービス、ビジネス、開発者向け連携情報をご確認ください。',
    ru: 'Информация о сервисе, бизнесе и интеграции для разработчиков Саджу ИИ.',
    de: 'Informationen zu Service, Geschäft und Entwickler-Integrationen von SajuPaljaAI.',
  },
  legal: {
    ko: '사주팔자AI 서비스 이용에 적용되는 정책과 주요 안내를 확인하세요.',
    en: 'Review the policies and important information that apply to the SajuPaljaAI service.',
    ja: '四柱八字AIサービスに適用されるポリシーと重要事項をご確認ください。',
    ru: 'Ознакомьтесь с правилами и важной информацией сервиса Саджу ИИ.',
    de: 'Lesen Sie die Richtlinien und wichtigen Hinweise für den SajuPaljaAI-Dienst.',
  },
};

function localized(ko, en, ja, ru, de) {
  return { ko, en, ja, ru, de };
}

function route(path, titles, description, options = {}) {
  return {
    path,
    indexable: true,
    changefreq: options.changefreq || 'weekly',
    priority: options.priority || 0.7,
    title: titles,
    description,
  };
}

const SEO_ROUTES = [
  route('/', localized('사주팔자AI | 전통 사주 · 4인 캐릭터 채팅', 'SajuPaljaAI | Saju Readings & 4 Chat Companions', '四柱八字AI | 伝統鑑定と4人のチャット相談', 'Саджу AI | Традиционный разбор и 4 собеседника', 'SajuPaljaAI | Saju-Deutung & 4 Chat-Begleiter'), descriptions.home, { changefreq: 'daily', priority: 1 }),
  route('/fortune', localized('전통 사주', 'Traditional Saju', '伝統四柱推命', 'Традиционный Сажу', 'Traditionelles Saju'), descriptions.service, { changefreq: 'daily', priority: 0.95 }),
  route('/saju-garden', localized('사주 정원 아트 | 원국과 대운 11장 · 99P', 'Saju Garden Art | 11 Personal Paintings · 99P', '四柱の庭アート | 命式と大運の11枚 · 99P', 'Сад Сажу | 11 личных картин · 99P', 'Saju-Gartenkunst | 11 persönliche Gemälde · 99P'), localized(
    '실제 만세력의 일간·계절·세력·용희신으로 개인별 물상 정원을 그립니다. 원국과 대운 10구간의 그림 11장을 99P(현금 환산 990원)에 보관하고 다운로드하세요.',
    'Personal symbolic gardens inspired by your calculated Saju chart. One natal painting and ten decade paintings are included for 99P (KRW 990 equivalent), with viewing and downloads.',
    '実際の命式から個別の象徴的な庭を描きます。命式1枚と大運10枚、計11枚を99P（990ウォン相当）で保存・閲覧できます。',
    'Личные символические сады по рассчитанной карте Сажу. Натальная картина и десять картин циклов за 99P (эквивалент 990 KRW), с просмотром и загрузкой.',
    'Persönliche symbolische Gärten nach Ihrem berechneten Saju-Chart. Ein Geburtsbild und zehn Zyklusbilder für 99P (entspricht 990 KRW), mit Ansicht und Downloads.'
  ), { priority: 0.85 }),
  route('/saju-webtoon', localized('캐릭터 개인화 웹툰 | 사주 6컷 이야기 · 99P', 'Personal Saju Webtoon | 6 Panels · 99P', '個別四柱ウェブトゥーン | 6コマ · 99P', 'Личный вебтун Сажу | 6 кадров · 99P', 'Persönlicher Saju-Webtoon | 6 Szenen · 99P'), localized(
    '네 캐릭터 중 한 친구를 선택하고 실제 사주에 기반한 개인별 6컷 웹툰을 만나보세요. 표정과 맞춤 대사가 담긴 작품을 99P(현금 환산 990원)에 제공합니다.',
    'Choose one of four companions for a six-panel webtoon with expressive portraits and personal dialogue based on your Saju chart. 99P, equivalent to KRW 990.',
    '4人から友だちを選び、命式に基づく表情豊かな6コマ物語を楽しみましょう。個別の台詞付き、99P（990ウォン相当）。',
    'Выберите одного из четырёх друзей для вебтуна в шести кадрах с личными диалогами по карте Сажу. 99P, эквивалент 990 KRW.',
    'Wählen Sie einen von vier Begleitern für sechs ausdrucksvolle Szenen mit persönlichen Dialogen zu Ihrem Saju-Chart. 99P, entspricht 990 KRW.'
  )),
  route('/life-scroll', localized('대운 인생 스크롤 | 10년마다 펼쳐지는 풍경 · 99P', 'Decade Life Scroll | Ten Chapters · 99P', '大運・人生の絵巻 | 10の章 · 99P', 'Свиток жизни Сажу | 10 глав · 99P', 'Saju-Lebensrolle | Zehn Kapitel · 99P'), localized(
    '실제 만세력의 대운 10구간을 수묵 풍경과 개인별 이야기로 펼쳐보세요. 99P(현금 환산 990원), 완성된 작품은 보관함에서 다시 볼 수 있습니다.',
    'Explore ten calculated decade cycles through ink landscapes and personal reflections. 99P, equivalent to KRW 990. Revisit finished works in your collection.',
    '命式の大運10区間を、水墨風景と個別の物語で読み進めましょう。99P（990ウォン相当）。完成作品は作品集に保存されます。',
    'Исследуйте десять рассчитанных циклов через тушевые пейзажи и личные истории. 99P, эквивалент 990 KRW. Работы остаются в коллекции.',
    'Erkunden Sie zehn berechnete Jahrzehntzyklen durch Tuschelandschaften und persönliche Gedanken. 99P, entspricht 990 KRW. Werke bleiben in Ihrer Sammlung.'
  )),
  route('/guardian-art', localized('AI 수호 그림 | 나만의 사주 물상 · 99P', 'AI Guardian Art | Personal Saju Symbols · 99P', 'AI・守りの絵 | 私の四柱の象徴 · 99P', 'Картина-хранитель с ИИ | Символы Сажу · 99P', 'KI-Schutzbild | Persönliche Saju-Symbole · 99P'), localized(
    '일간·계절·용희신을 바탕으로 개인별 물상 그림을 생성합니다. 나만의 그림 한 장과 의미를 99P(현금 환산 990원)에 받아보세요.',
    'Your day master, birth season and balancing elements inspire one personal symbolic painting and its story. 99P, equivalent to KRW 990.',
    '日干、季節、均衡を補う要素から個別の象徴画を生成します。一枚の絵と意味を99P（990ウォン相当）で。',
    'Образ личности, сезон рождения и элементы баланса вдохновляют личную символическую картину и её историю. 99P, эквивалент 990 KRW.',
    'Tagesstamm, Geburtsjahreszeit und ausgleichende Elemente inspirieren Ihr Symbolbild und seine Geschichte. 99P, entspricht 990 KRW.'
  )),
  route('/tarot', localized('AI 타로 리딩', 'AI Tarot Reading', 'AIタロット占い', 'Расклад Таро с ИИ', 'KI-Tarotlegung'), descriptions.service, { changefreq: 'daily', priority: 0.9 }),
  route('/gunghap', localized('AI 궁합 분석', 'AI Compatibility Reading', 'AI相性診断', 'ИИ-анализ совместимости', 'KI-Partneranalyse'), descriptions.service, { priority: 0.9 }),
  route('/saju-pro', localized('만세력 프로', 'Professional Saju Birth Chart', 'プロ万歳暦', 'Профессиональная карта Саджу', 'Professioneller Saju-Geburtschart'), descriptions.service, { priority: 0.85 }),
  route('/manseryeok-ai', localized('AI 만세력 해석', 'AI Birth Chart Interpretation', 'AI万歳暦解釈', 'ИИ-толкование карты судьбы', 'KI-Geburtschart-Deutung'), descriptions.service, { priority: 0.82 }),
  route('/encyclopedia', localized('사주 명리 백과사전', 'Saju Encyclopedia', '四柱推命百科事典', 'Энциклопедия Саджу', 'Saju-Lexikon'), descriptions.service, { priority: 0.8 }),
  route('/board', localized('운세 이야기 게시판', 'Fortune Community Board', '運勢コミュニティ掲示板', 'Форум о судьбе', 'Schicksalsforum'), descriptions.community, { changefreq: 'daily', priority: 0.75 }),
  route('/gallery', localized('촉점 갤러리', 'Intuition Gallery', '直感ギャラリー', 'Галерея интуиции', 'Intuitionsgalerie'), descriptions.community, { changefreq: 'daily', priority: 0.75 }),
  route('/psychtest', localized('나를 알아가는 심리 테스트', 'Self-Reflection Quizzes', '自分を知る心理テスト', 'Тесты для самопознания', 'Tests zur Selbstreflexion'), localized(
    '성격, 관계, 일상의 선택을 가볍게 살펴보세요. 선택한 답변에 연결된 결과 근거와 비슷한 성향을 함께 확인하는 모비딕 심리 테스트입니다.',
    'Explore personality, relationships and everyday preferences with Mobidic quizzes. See how your answers relate to each result. For reflection and fun, not clinical assessment.',
    '性格や関係、日常の選択を気軽に振り返るモビディックの心理テスト。選んだ答えと結果のつながりを確認できます。医療的な診断ではありません。',
    'Тесты Мобидик помогают осмыслить повседневные предпочтения и отношения. Узнайте, как ответы связаны с результатом. Для самопознания и развлечения, не для диагностики.',
    'Entdecke mit Mobidic deine Vorlieben im Alltag und in Beziehungen. Sieh, wie deine Antworten zum Ergebnis beitragen. Zur Selbstreflexion und Unterhaltung, keine klinische Diagnose.'
  )),
  route('/developer', localized('개발자 API', 'Developer API', '開発者API', 'API для разработчиков', 'Entwickler-API'), descriptions.company),
  route('/franchise', localized('사주팔자AI 가맹 안내', 'SajuPaljaAI Franchise', '四柱八字AI加盟案内', 'Франшиза Саджу ИИ', 'SajuPaljaAI-Partnerschaft'), descriptions.company),
  route('/saju-farm', localized('사주팜', 'Saju Farm', '四柱ファーム', 'Ферма Саджу', 'Saju-Farm'), descriptions.service),
  route('/ascii-tarot', localized('ASCII 타로', 'ASCII Tarot', 'ASCIIタロット', 'ASCII Таро', 'ASCII-Tarot'), descriptions.service),
  route('/ascii-tarot-gallery', localized('ASCII 타로 갤러리', 'ASCII Tarot Gallery', 'ASCIIタロットギャラリー', 'Галерея ASCII Таро', 'ASCII-Tarot-Galerie'), descriptions.community),
  route('/celebrities', localized('유명인 사주', 'Celebrity Saju', '有名人の四柱推命', 'Саджу знаменитостей', 'Prominenten-Saju'), descriptions.service, { changefreq: 'daily', priority: 0.8 }),
  route('/live', localized('운세 라이브 라운지', 'Fortune Live Lounge', '運勢ライブ・ラウンジ', 'Прямой эфир о судьбе', 'Live-Lounge für Schicksalsfragen'), descriptions.community, { changefreq: 'daily', priority: 0.8 }),
  route('/astrology', localized('AI 서양 점성술', 'AI Western Astrology', 'AI西洋占星術', 'Западная астрология с ИИ', 'Westliche Astrologie mit KI'), descriptions.service, { priority: 0.85 }),
  route('/saju-map', localized('전국 점집 지도', 'Korea Fortune Shop Map', '韓国占い店マップ', 'Карта гадальных салонов Кореи', 'Karte koreanischer Wahrsagestätten'), descriptions.service),
  route('/privacy', localized('개인정보처리방침', 'Privacy Policy', 'プライバシーポリシー', 'Политика конфиденциальности', 'Datenschutzerklärung'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
  route('/terms', localized('이용약관', 'Terms of Service', '利用規約', 'Условия использования', 'Nutzungsbedingungen'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
  route('/refund-policy', localized('환불 정책', 'Refund Policy', '返金ポリシー', 'Политика возврата', 'Rückerstattungsrichtlinie'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
];

const ROUTE_BY_PATH = new Map(SEO_ROUTES.map(entry => [entry.path, entry]));
const PREFIX_PATTERN = new RegExp(`^/(${PREFIXED_LOCALES.join('|')})(?=/|$)`);
const PRIVATE_PATTERNS = [
  /^\/saju-report(?:\/|$)/,
  /^\/character-chat(?:\/|$)/,
  /^\/(?:login|register|social-signup|kakao-channel|forgot-password|reset-password|login-success)(?:\/|$)/,
  /^\/(?:mypage|myeongri|notifications|charge|result|tarot-result|manseryeok-history|usage-history|saju-history)(?:\/|$)/,
  /^\/(?:admin|admin-dashboard|admin-erp)(?:\/|$)/,
  /^\/payment(?:-|\/)/,
  /^\/(?:board|gallery)\/(?:write|edit)(?:\/|$)/,
  /^\/live\/(?:chat|voice|radio)(?:\/|$)/,
  /^\/astrology\/r(?:\/|$)/,
  /^\/psychtest\/(?:[^/]+)(?:\/|$)/,
];

function normalizePath(pathname = '/') {
  const withoutPrefix = pathname.replace(PREFIX_PATTERN, '') || '/';
  if (withoutPrefix.length > 1) return withoutPrefix.replace(/\/+$/, '');
  return withoutPrefix;
}

function localizePath(path, locale = DEFAULT_LOCALE) {
  const logicalPath = normalizePath(path);
  if (locale === DEFAULT_LOCALE) return logicalPath;
  return logicalPath === '/' ? `/${locale}` : `/${locale}${logicalPath}`;
}

function classifySeoRoute(pathname) {
  const path = normalizePath(pathname);
  const entry = ROUTE_BY_PATH.get(path);
  if (entry) return { indexable: entry.indexable, path, entry };
  const isPrivate = PRIVATE_PATTERNS.some(pattern => pattern.test(path));
  return { indexable: false, private: isPrivate, path, entry: null };
}

function getLocalizedSeo(entry, locale = DEFAULT_LOCALE) {
  const safeLocale = LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  return {
    title: entry.title[safeLocale] || entry.title[DEFAULT_LOCALE],
    description: entry.description[safeLocale] || entry.description[DEFAULT_LOCALE],
  };
}

module.exports = {
  DEFAULT_LOCALE,
  LOCALES,
  OG_LOCALES,
  PREFIXED_LOCALES,
  SEO_ROUTES,
  SITE_NAME,
  SITE_NAMES,
  SITE_URL,
  classifySeoRoute,
  getLocalizedSeo,
  localizePath,
  normalizePath,
};
